import classNames from 'classnames';
import { FunctionComponent } from 'react';

interface BSpinnerInlineProps {
  size?: number;
  color?: string;
  className?: string;
}

const BSpinnerInline: FunctionComponent<BSpinnerInlineProps> = ({
  size = 32,
  className,
  color = 'primary-500',
}) => {
  return (
    <>
      <div className={classNames('loader', className)} />
      <style jsx>{`
        .loader {
          width: ${size}px;
          height: ${size}px;
          border-radius: 50%;
          position: relative;
          animation: rotate 1s linear infinite;
        }
        .loader::before {
          content: '';
          box-sizing: border-box;
          position: absolute;
          inset: 0px;
          border-radius: 50%;
          border: 3px solid var(--clr-${color});
          animation: prixClipFix 2s linear infinite alternate;
        }

        @keyframes rotate {
          100% {
            transform: rotate(360deg);
          }
        }

        @keyframes prixClipFix {
          0% {
            clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
          }
          25% {
            clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
          }
          50% {
            clip-path: polygon(
              50% 50%,
              0 0,
              100% 0,
              100% 100%,
              100% 100%,
              100% 100%
            );
          }
          75% {
            clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);
          }
          100% {
            clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
          }
        }
      `}</style>
    </>
  );
};

export default BSpinnerInline;
